import React, { Component } from 'react'
import { observer } from 'mobx-react'
import {
    Col,
    Grid,
    Row,
    Tab,
    Tabs
} from 'react-bootstrap'
import { Elements } from 'react-stripe-elements'
import Loadable from 'react-loading-overlay'

import NewCardForm from './newcardform'
import InvoiceDetails from './invoicedetails'
import SavedCardForm from './savedcardform'

@observer(['companies', 'globals', 'invoices', 'quickbooks'])
export default class ProcessPayment extends Component {

    constructor(props) {
        super(props)

        console.log('Initial Props: ', props);

        this.state = {
            loadableState: false,
            sources: []
        }
    }

    setLoadableState(state) {
        this.setState({
            loadableState: state
        })
    }

    render() {

        let paymentTab = 'Loading...'
        let newCardTab = ''
        let savedCardTab = ''

        if (this.props.invoices.invoiceViewDetails.paymentId !== null) {
            paymentTab = (
                <Row>
                    <Col>
                        <h2>YOU HAVE ALREADY PAID FOR THIS QUOTE!</h2>
                    </Col>
                </Row>
            )
        } else {
            newCardTab = (
                <Tab eventKey={1} title="New Card">
                    <div style={
                        {
                            marginBottom: '20px',
                            padding: '15px',
                            backgroundColor: '#FFF'
                        }
                    }>
                        <NewCardForm invoiceToken={this.props.token} setLoadableState={ this.setLoadableState.bind(this) } />
                    </div>
                </Tab>
            )
    
            if (this.props.invoices.invoiceDetail.stripeCustomerId != '') {
                savedCardTab = (
                    <Tab eventKey={2} title="Saved Card">
                        <div style={
                            {
                                marginBottom: '20px',
                                padding: '15px',
                                backgroundColor: '#FFF'
                            }
                        }>
                            <SavedCardForm invoice={this.props.invoices.invoiceDetail} />
                        </div>
                    </Tab>
                )
            }

            paymentTab = (
                <Tabs id="payment-option-tabs">
                    {newCardTab}
                    {savedCardTab}
                </Tabs>
            )
        }

        return (
            <div className="checkout-container">
                <Grid>
                    <Row className="center">
                        <Col>
                            <h1>Process Payment</h1>
                        </Col>
                    </Row>
                </Grid>
                <Loadable active={this.state.loadableState} spinner text='Preparing your request...'>
                    <div>
                        <Grid>
                            <Row>
                                <Col>
                                    <InvoiceDetails token={this.props.token} emailStatus={false} setLoadableState={this.setLoadableState.bind(this)} />
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <div className="col-xs-12 invoice-header">
                                        <h1><i className="fa fa-credit-card"></i> Card Information</h1>
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Elements>
                                        {paymentTab}
                                    </Elements>
                                </Col>
                            </Row>
                        </Grid>
                    </div>
                </Loadable>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/invoices/processpayment.js